import React, { forwardRef } from 'react';

const badgeBaseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: '9999px',
    border: '1px solid transparent',
    padding: '0.125rem 0.625rem',
    fontSize: '0.75rem',
    fontWeight: '600',
    lineHeight: '1',
    transition: 'colors 0.2s ease-in-out',
    whiteSpace: 'nowrap'
};

const variants = {
    default: { backgroundColor: '#18181b', color: '#fff' },
    secondary: { backgroundColor: '#f1f5f9', color: '#18181b' },
    destructive: { backgroundColor: '#ef4444', color: '#fff' },
    outline: { color: '#0f172a', border: '1px solid #e5e7eb' },

    // Custom mimic from Tailwind classes used in Voice
    'bg-green-100 text-green-800': { backgroundColor: '#dcfce7', color: '#166534', borderColor: '#bbf7d0' },
    'bg-blue-100 text-blue-800': { backgroundColor: '#dbeafe', color: '#1e40af', borderColor: '#bfdbfe' },
    'bg-orange-100 text-orange-800': { backgroundColor: '#ffedd5', color: '#9a3412', borderColor: '#fed7aa' },
    'bg-red-100 text-red-800': { backgroundColor: '#fee2e2', color: '#991b1b', borderColor: '#fecaca' },
    'bg-gray-100 text-gray-800': { backgroundColor: '#f3f4f6', color: '#1f2937', borderColor: '#e5e7eb' },
    'bg-purple-100 text-purple-800': { backgroundColor: '#f3e8ff', color: '#6b21a8', borderColor: '#e9d5ff' },
};

function Badge({ className, variant = "default", style, ...props }) {
    // If className matches one of our keys, use it.
    // Otherwise fallback to variant or default.
    // This is a naive way to support the dynamic classNames passed from Voice components.

    let activeStyle = variants[variant] || variants.default;

    // Check if className contains specific colors if variant is default
    if (className) {
        if (className.includes('green')) activeStyle = variants['bg-green-100 text-green-800'];
        else if (className.includes('blue')) activeStyle = variants['bg-blue-100 text-blue-800'];
        else if (className.includes('orange')) activeStyle = variants['bg-orange-100 text-orange-800'];
        else if (className.includes('red')) activeStyle = variants['bg-red-100 text-red-800'];
        else if (className.includes('gray')) activeStyle = variants['bg-gray-100 text-gray-800'];
        else if (className.includes('purple')) activeStyle = variants['bg-purple-100 text-purple-800'];
    }

    return (
        <div
            style={{ ...badgeBaseStyle, ...activeStyle, ...style }}
            {...props}
        />
    );
}

export { Badge, badgeBaseStyle as badgeStyle };
